import { createSelector } from "reselect";
const selector = (state) => state.filters;

export default createSelector([selector], (data) => data);